export default __webpack_public_path__ + "static/media/icn-upload-24px.f7450284.svg";